import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'DbNumberParseFloatPipe',
    standalone: true
})

export class DbNumberParseFloatPipe implements PipeTransform {
    transform(value: string): number {
        return parseFloat(value);
    }
}
